export default __webpack_public_path__ + "static/media/新建.ad8bd521.png";